import api from "PFCore/api";
import { Collection, Template } from "PFTypes";

export const fetchTemplates = (params: {
  accountId: string;
  page: number;
  perPage: number;
}): Promise<Collection<Template[]>> => api({ url: "templates", params });

export const saveActivityTemplateState = (
  activityTemplateId: string,
  accountId: string,
  state: boolean
): Promise<Template> =>
  api({
    url: `templates/${activityTemplateId}/${state ? "activate" : "deactivate"}`,
    method: "PUT",
    data: {
      accountId
    }
  });
